import React, { useContext } from 'react';
import classNames from 'classnames';
import DataRoomContext from '../../providers/DataRoom/DataRoom.context';
import HelmetWrapper from 'components/HelmetWrapper';
import DashMembers from './componenets/DashMembers';
import DashDocuments from './componenets/DashDocuments';
import { Navigate } from 'react-router-dom';
import { Button } from 'ncoded-component-library';
import WandIcon from 'icons/Wand.icon';
import useMatchMedia from 'hooks/useMatchMedia';
import OnboardingContext from '../../providers/Onboarding/Onboarding.context';
import { MOBILE_DASHBOARD_SELECTOR } from '../../providers/Onboarding/data';

import './Dashboard.styles.scss';
import './Dashboard.styles.responsive.scss';

type DashboardProps = {
  className?: string;
};

const Dashboard: React.FC<DashboardProps> = (props) => {
  const { className } = props;

  const {
    isAdmin,
    dataRoom: { name },
  } = useContext(DataRoomContext);
  const { canUserSeeOnboarding, onShowOnboarding } =
    useContext(OnboardingContext);

  const isPhablet = useMatchMedia('isPhablet');

  const classes = classNames('dashboard', 'page', className);

  if (!isAdmin) return <Navigate to="../documents" replace />;

  return (
    <div className={classes}>
      <HelmetWrapper title={`Dashboard - ${name}`} />
      <div className="dashboard__name">
        <h2 id={MOBILE_DASHBOARD_SELECTOR}>{name}</h2>
        {isPhablet && canUserSeeOnboarding && (
          <Button variant="icon" icon={WandIcon} onClick={onShowOnboarding} />
        )}
      </div>

      <div className="dashboard__container">
        <DashMembers />
        <DashDocuments />
      </div>
    </div>
  );
};

export default Dashboard;
